'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createForm = undefined;

var _createForm = require('./createForm');

var _createForm2 = _interopRequireDefault(_createForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.createForm = _createForm2['default']; // export this package's api


//////////////////
// WEBPACK FOOTER
// ./~/rc-form/lib/index.js
// module id = 310
// module chunks = 0